<script setup lang="ts">
/** 공통 회사 헤더 — Company Name + [Registration No. (+ 구번호)] + (Incorporated in Malaysia). (OtcDocHead 미러링.) */
import { computed, inject } from 'vue';
import { BONUS_DOC_CTX } from '../bonusContext';
import BonusDocVarField from '../BonusDocVarField.vue';

withDefaults(defineProps<{ showReg?: boolean }>(), { showReg: true });

const ctx = inject(BONUS_DOC_CTX)!;
const hasOldReg = computed(() => !!String(ctx.valueOf('old_registration_no') || '').trim());
</script>

<template>
  <div class="doc-head">
    <div class="doc-company"><BonusDocVarField field-key="company_name" /></div>
    <div v-if="showReg" class="doc-meta">
      [Company Registration No. <BonusDocVarField field-key="company_registration_no" /><template v-if="hasOldReg"> (<BonusDocVarField field-key="old_registration_no" />)</template>]
    </div>
    <div class="doc-meta italic">(Incorporated in Malaysia)</div>
  </div>
</template>
